import StudentFollowUp from '@/api/student-follow-up'
import StudentInquiry from '@/api/info-inquiry'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  action_date: moment().format('DD-MM-YYYY'),
  infoInquiries: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ACTION_DATE(state, data) {
    state.action_date = data
  },
  SET_INFO_INQUIRIES(state, data) {
    state.infoInquiries = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        action_date: context.state.action_date
      },
      attrubutes
    )
    return StudentFollowUp.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return StudentFollowUp.store(data)
  },

  update(context, data) {
    return StudentFollowUp.update(data)
  },

  previewPdf(context) {
    return StudentFollowUp.previewPdf({
      action_date: context.state.action_date
    })
  },

  fetchInfoInquiries(context, attributes = {}) {
    let params = {
      page: -1,
      search: attributes,
      fields: {
        setup_student_inquiries:
          'first_name_kh,last_name_kh,first_name_en,last_name_en,gender,date_of_birth,place_of_birth,province_code,district_code,commune_code,village_code,street,house,ac_st_id,na_id,email,facebook,linkin,telegram,line,we_chat,contact_name,relationship,contact_number,inquiry_id,created_date'
      },
      filter: { is_registered: false, not_in_student_follow_up: true },
      ...attributes
    }

    return StudentInquiry.get({ params }).then(response => {
      context.commit('SET_INFO_INQUIRIES', response.data)
      return Promise.resolve(response)
    })
  }
}
